module.exports = __webpack_public_path__ + "static/media/8-lincoln-nh-08_04_2020.242e8e6b.jpg";